<div class="notifications">
	<div *ngFor="let notification of notifications" class="notification" [ngClass]="className(notification)">
		<ng-container *ngTemplateOutlet="notificationTpl;context:{notification:notification}"></ng-container>
	</div>
</div>

<ng-template #notificationTpl let-notification="notification">
	<div class="flex justify-space-between align-center">
		<div class="border" [ngStyle]="{'background-color':getColor(notification.type)}"></div>
		<div class="message">{{notification.message}}</div>
		<button mat-icon-button 
			(click)="close(notification, 'manual')"
			matTooltip="Close the notification"
			matTooltipPosition="before"
		>
		<img src="../../../../assets/notification-cross.svg" alt="">
  		</button>
	</div>

</ng-template>
